var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.token !== null || _vm.token)?_c('div',[(_vm.token.signInProvider === 'password')?_c('default-list',{staticClass:"mb-n2",attrs:{"items":_vm.items}}):_c('default-list',{staticClass:"mb-n2",attrs:{"items":_vm.itemsCustom}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }